/* Atelier - band reveal.

   Split out of atelier-pdp-layout.js because an animation that can leave content invisible
   is the highest-consequence thing on this page, and it deserves to be readable on its own.

   A plain IntersectionObserver is not enough here. The band sections are taller than the
   viewport, and a jump-scroll - an in-page anchor, a restored scroll position, a back
   navigation - can take a section from "below the fold" to "above the fold" without it ever
   intersecting. Measured: after two instant scrolls the Details section stayed at opacity 0
   with the page scrolled past it.

   Three guards, in order of how early they catch it:
     1. never hide a section that is already at or above the fold when the class is applied
     2. reveal on leaving through the TOP as well as on entering
     3. a timed sweep, so nothing can end up permanently invisible */
(function () {
  'use strict';

  var SEC = '.gf-pdp-band__sec';
  var ARMED = 'gf-band-rv';
  var SHOWN = 'is-in';

  function show(el) {
    el.classList.add(SHOWN);
  }

  function inViewOrPast(el) {
    return el.getBoundingClientRect().top < window.innerHeight;
  }

  var io = null;

  function observer() {
    if (io) return io;
    if (!('IntersectionObserver' in window)) return null;

    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        /* bottom <= 0 means the section has left through the top of the viewport, which a
           jump-scroll can do without ever reporting isIntersecting. */
        if (e.isIntersecting || e.boundingClientRect.bottom <= 0) {
          show(e.target);
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.03 });

    return io;
  }

  function arm() {
    var band = document.querySelector('.gf-pdp-band');
    if (!band) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var obs = reduced ? null : observer();

    [].forEach.call(band.querySelectorAll(SEC), function (sec) {
      if (sec.hidden || sec.classList.contains(ARMED)) return;

      /* Armed from script, never from the stylesheet, so a section is only ever hidden
         once something exists that can show it again. */
      sec.classList.add(ARMED);

      if (!obs || inViewOrPast(sec)) {
        show(sec);
        return;
      }
      obs.observe(sec);
    });
  }

  function sweep() {
    var stuck = document.querySelectorAll('.' + ARMED + ':not(.' + SHOWN + ')');
    [].forEach.call(stuck, function (sec) {
      if (inViewOrPast(sec)) show(sec);
    });
  }

  /* Last resort. If anything above has gone wrong, content wins over animation. */
  function release() {
    [].forEach.call(document.querySelectorAll('.' + ARMED), show);
  }

  window.AtelierBandReveal = { arm: arm };

  window.addEventListener('scroll', function () {
    if (document.querySelector('.' + ARMED + ':not(.' + SHOWN + ')')) sweep();
  }, { passive: true });

  window.setTimeout(sweep, 3000);
  window.setTimeout(release, 12000);
})();